import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Apply from './pages/Apply';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';

const PrivateRoutes = () => {
  const { isAuthenticated, isLoading, isApproved } = useAuth();
  if (isLoading) return <p className="p-8 text-center">Loading…</p>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to={isApproved ? '/jobs' : '/onboarding'} replace />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/onboarding/agreement/mock-sign" element={<Onboarding />} />
        <Route
          path="/jobs"
          element={isApproved ? <Jobs /> : <Navigate to="/onboarding" replace />}
        />
        <Route
          path="/jobs/:id"
          element={isApproved ? <JobDetail /> : <Navigate to="/onboarding" replace />}
        />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/*" element={<PrivateRoutes />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
